import axios, { AxiosHeaders } from "axios";
import { msalInstance } from "./AuthProvider";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

// Define your scopes
const SCOPES = ["api://650ce438-b6ac-40c9-8226-5c8f45213dcf/Chat.User"];

const authAxios = axios.create();

authAxios.interceptors.request.use(
  async (config) => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) return config;

    try {
      const response = await msalInstance.acquireTokenSilent({
        scopes: SCOPES,
        account: accounts[0],
      });

      // ✅ Use AxiosHeaders to set headers properly
      config.headers = new AxiosHeaders({
        ...config.headers?.toJSON?.(), // merge any existing headers
        Authorization: `Bearer ${response.accessToken}`,
      });

    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        console.warn("Token requires interaction. Redirecting or prompting user...");
        // Optional: trigger redirect or popup
      } else {
        console.error("Token acquisition failed", error);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default authAxios;